import { eur } from "./format";
import { useT } from "./i18n";

export function QuoteSummary({ repairTotal, extras, extrasTotal, grandTotal, testidPrefix = "summary" }) {
  const { t } = useT();
  return (
    <div className="space-y-1.5" data-testid={`${testidPrefix}-box`}>
      <div className="flex justify-between text-sm">
        <span className="text-[#525252]">{t("original_quote")}</span>
        <span className="font-mono font-semibold" data-testid={`${testidPrefix}-repair-total`}>{eur(repairTotal)}</span>
      </div>
      {extras.length > 0 && (
        <div className="pt-1">
          <div className="text-sm text-[#525252]">{t("selected_extras")}</div>
          {extras.map((e) => (
            <div key={e.id || e.rule_id} className="flex justify-between text-xs pl-3 py-0.5">
              <span className="text-[#111110] truncate pr-2">{e.title}</span>
              <span className="font-mono shrink-0">{eur(e.price)}</span>
            </div>
          ))}
          <div className="flex justify-between text-sm pt-1">
            <span className="text-[#525252]">{t("extras_total")}</span>
            <span className="font-mono font-semibold" data-testid={`${testidPrefix}-extras-total`}>{eur(extrasTotal)}</span>
          </div>
        </div>
      )}
      <div className="flex justify-between items-baseline border-t border-[#E5E5E0] pt-2 mt-1">
        <span className="font-mono text-[10px] uppercase tracking-widest text-[#525252]">{t("total_vat")}</span>
        <span className="font-display font-black text-xl text-[#111110]" data-testid={`${testidPrefix}-grand-total`}>{eur(grandTotal)}</span>
      </div>
    </div>
  );
}
